import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Photo } from '@classifieds-sell/trademe-core-ui';
import { Subject } from 'rxjs';
import { StepIds } from '../../../models/motors-step/motors-step-model';
import { MotorsDraftFacade } from '@classifieds-sell/state';
import { MotorsSectionBase } from '../../motors-section-base';

@Component({
    selector: 'motors-summary-page-photos-media-section',
    templateUrl: './summary-page-vehicle-photos-media-section.component.html',
    styleUrls: ['./summary-page-vehicle-photos-media-section.component.scss'],
    standalone: false
})
export class SummaryPageVehiclePhotosMediaSectionComponent
    extends MotorsSectionBase
    implements OnInit, OnDestroy {
    stepIds = StepIds;

    private _destroyed$: Subject<void> = new Subject<void>();

    photos: Photo[] = [];
    youTubeVideoUrl: string;

    constructor(
        draftFacade: MotorsDraftFacade,
        private _changeDetectorRef: ChangeDetectorRef
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.photos = this.draftData?.descriptionAndPhotos?.photos || [];
            this.youTubeVideoUrl = this.draftData?.descriptionAndPhotos?.youTubeVideoUrl;
            this._changeDetectorRef.markForCheck();
        });
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }
}
